import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";

export default function StatusCheckModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const { userid } = useSession();
  

  const validateForm = () => {
    const requiredFields = ["date", "requestid"];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const value = document.querySelector(`[name="${field}"]`)?.value?.trim();
      if (!value) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCheckStatus = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before submitting.", "danger");
      return;
    }

    const formData = new FormData(document.getElementById("status-check-form"));
    // formData.append("action", "StatusCheck");
    formData.append("userid", userid);
    // formData.append("id", userData?.id || "");

    try {
      const response = await fetchWrapper("https://pro.mokshiq.in/nsdl_status_check", {
        method: "POST",
        body: formData,
      });

     
      if (response.status) {
        showMainToast(response.data || "Status retrieved successfully!", "success");
        if (onSuccess) onSuccess(response);
        onClose();
      } else {
        showMainToast(response.data || "Unable to fetch status.", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="Check Application Status"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: "Check Status", className: "btn-primary", onClick: handleCheckStatus },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="status-check-form">
             {/* Request ID */}
          <div className="col-md-6">
            <label className="form-label">Request ID</label>
            <input
              className={`form-control ${errors.requestid ? "is-invalid" : ""}`}
              name="requestid"
              type="text"
              defaultValue={userData?.requestid || ""}
            />
            {errors.requestid && (
              <div className="text-danger mt-1">{errors.requestid}</div>
            )}
          </div>
          {/* Application Date */}
          <div className="col-md-6">
            <label className="form-label">Application Date</label>
            <input
              className={`form-control ${errors.applicationdate ? "is-invalid" : ""}`}
              name="date"
              type="date"
              defaultValue={userData?.applicationdate || ""}
            />
            {errors.applicationdate && (
              <div className="text-danger mt-1">{errors.applicationdate}</div>
            )}
          </div>

         
        </form>
      </div>
    </BaseModal>
  );
}
